import { getCookie } from '@/utils';
import { GUANCEYUN_VERSION } from '@/version';

function rewriteXMLHttpRequest() {
  if (XMLHttpRequest) {
    const originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (body) {
      // @ts-ignore
      this._requestParams = body;
      // 调用原始 send 方法
      originalSend.call(this, body);
    };
  }
}

const initCloudCare = () => {
  if (typeof window !== 'undefined') {
    rewriteXMLHttpRequest();
    const init = async () => {
      const { datafluxRum } = await import('@cloudcare/browser-rum');
      try {
        datafluxRum.init({
          applicationId: 'marketing_ai_aws',
          env: process.env.NEXT_PUBLIC_ENV + '_' + process.env.APP_AREA,
          site: 'https://us1-rum-openway.guance.com',
          clientToken: '75a9383fcbb548cbaf1d70041c370129',
          version: GUANCEYUN_VERSION,
          service: 'browser',
          sessionSampleRate: 100,
          sessionReplaySampleRate: 100,
          trackUserInteractions: true,
          traceType: 'ddtrace' as any,
          beforeSend: (event, context) => {
            if (event.type === 'resource' && event.resource.type === 'fetch') {
              if (event.resource.url_path.includes('/alive')) {
                return false;
              }
              return true;
            }
            if (event.type === 'resource' && event.resource.type === 'xhr') {
              event.resource.url = `requestData=${context.xhr?._requestParams || ''}&responseData=${JSON.stringify(context.xhr?.response || {})}`;
            }
            return true;
          },
        });
        const accountId = localStorage.getItem('accountId');
        const uid = getCookie('user').uid || '';
        const cookieName = getCookie('user')?.email || getCookie('user')?.accountId;
        datafluxRum.setUser({ name: cookieName, id: uid || accountId });
        // 开启会话重放功能
        datafluxRum.startSessionReplayRecording();
      } catch (error) {}
    };
    init();
  }
};

export default initCloudCare;
